import { useState } from "react";
import Nav from "@/components/site/Nav";
import Footer from "@/components/site/Footer";
import SectionBadge from "@/components/site/SectionBadge";
import BookConsultationDialog from "@/components/site/BookConsultationDialog";
import JoinUsDialog from "@/components/site/JoinUsDialog";
import FloatingActions from "@/components/site/FloatingActions";
import { usePageMeta } from "@/lib/usePageMeta";

const GRID = "max-w-7xl mx-auto px-6 sm:px-8 md:px-12";

/**
 * Shared layout for legal/informational pages
 * (Privacy Policy, Terms of Use).
 * sections: [{ heading, paras?: string[], bullets?: string[] }]
 */
export default function LegalPage({ testid, badge, title, intro, updated, sections, meta }) {
  const [bookOpen, setBookOpen] = useState(false);
  const [joinOpen, setJoinOpen] = useState(false);

  usePageMeta(meta);

  return (
    <div data-testid={testid} className="relative">
      <Nav onBook={() => setBookOpen(true)} />

      <section className="pt-32 md:pt-40 pb-12 md:pb-16 bg-[#fafafa]">
        <div className={GRID}>
          <SectionBadge label={badge} />
          <h1 className="font-serif-display text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[1.05] max-w-3xl">
            {title}
          </h1>
          <p className="mt-6 text-lg text-zinc-600 leading-relaxed max-w-2xl">{intro}</p>
          <p data-testid={`${testid}-updated`} className="mt-6 text-xs uppercase tracking-[0.2em] text-zinc-400">
            Last updated: {updated}
          </p>
        </div>
      </section>

      <section className="pb-20 md:pb-24 bg-[#fafafa]">
        <div className={GRID}>
          <div className="max-w-3xl border-t border-black/10 pt-10 space-y-10">
            {sections.map((s, i) => (
              <div key={s.heading} data-testid={`${testid}-section-${i + 1}`}>
                <h2 className="font-serif-display text-2xl leading-snug">
                  {i + 1}. {s.heading}
                </h2>
                {s.paras?.map((p) => (
                  <p key={p.slice(0, 40)} className="mt-4 text-base text-zinc-600 leading-relaxed">
                    {p}
                  </p>
                ))}
                {s.bullets && (
                  <ul className="mt-4 space-y-2 list-disc pl-5 text-base text-zinc-600 leading-relaxed">
                    {s.bullets.map((b) => (
                      <li key={b.slice(0, 40)}>{b}</li>
                    ))}
                  </ul>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      <Footer onJoin={() => setJoinOpen(true)} />
      <FloatingActions onBook={() => setBookOpen(true)} />
      <BookConsultationDialog open={bookOpen} onOpenChange={setBookOpen} />
      <JoinUsDialog open={joinOpen} onOpenChange={setJoinOpen} />
    </div>
  );
}
